(function () {
  function initSection(root) {
    if (!root || root.dataset.kbcInit === 'true') return;
    root.dataset.kbcInit = 'true';

    var highlightBtn = root.querySelector('[id^="kbc-highlight-"]');
    var viewMoreBtn = root.querySelector('.kbc-view-more');
    var mobileTabBar = root.querySelector('.kbc-mobile-tab-bar');
    var highlightOn = false;
    var activeKbs = [0, 1];
    var mobileMq = window.matchMedia('(max-width: 1023px)');

    function isMobile() {
      return mobileMq.matches;
    }

    function getCards() {
      return root.querySelectorAll('.kb-card');
    }

    function getComparisonCards() {
      var cards = Array.from(getCards());
      if (!isMobile()) return cards;
      return cards.filter(function (card) {
        return card.style.display !== 'none';
      });
    }

    function getVisiblePanel(card) {
      return card.querySelector('.kb-product-panel.is-active');
    }

    function showPanel(card, blockIndex) {
      if (!card) return;
      card.querySelectorAll('.kb-product-panel').forEach(function (panel) {
        var isActive = panel.dataset.blockIndex === String(blockIndex);
        panel.classList.toggle('is-active', isActive);
        panel.classList.toggle('kbc-hidden', !isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    function initPanelVisibility() {
      getCards().forEach(function (card) {
        var active = card.querySelector('.kb-product-panel.is-active');
        if (!active) {
          var first = card.querySelector('.kb-product-panel');
          if (first) showPanel(card, first.dataset.blockIndex);
        }
      });
    }

    function equalizeElements(elements) {
      if (!elements.length) return;
      elements.forEach(function (el) {
        // reset for measurement
        el.style.minHeight = '';
        el.style.height = '';
      });
      var maxHeight = 0;
      elements.forEach(function (el) {
        maxHeight = Math.max(maxHeight, el.offsetHeight);
      });
      if (maxHeight > 0) {
        elements.forEach(function (el) {
          // lock row height to the tallest in this horizontal group
          el.style.minHeight = '';
          el.style.height = maxHeight + 'px';
        });
      }
    }

    function updateMobileTabLabels() {
      root.querySelectorAll('.kbc-kb-tab').forEach(function (tab) {
        var card = root.querySelector('.kb-card[data-kb="' + tab.dataset.kbIdx + '"]');
        var labelEl = tab.querySelector('.kbc-kb-tab-label');
        if (!card || !labelEl) return;
        var dropdownLabel = card.querySelector('.rk-dropdown-label');
        var panel = getVisiblePanel(card);
        var title = dropdownLabel
          ? dropdownLabel.textContent.trim()
          : panel && panel.dataset.title
            ? panel.dataset.title
            : '';
        labelEl.textContent = title;
      });
    }

    function notifyLayoutChange() {
      root.dispatchEvent(
        new CustomEvent('kbc:layout-change', {
          bubbles: true
        })
      );
    }

    function renderKbSelection() {
      root.querySelectorAll('.kbc-kb-tab').forEach(function (tab) {
        var idx = parseInt(tab.dataset.kbIdx, 10);
        var active = activeKbs.indexOf(idx) !== -1;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      getCards().forEach(function (card) {
        var idx = parseInt(card.dataset.kb, 10);
        if (isMobile()) {
          card.style.display = activeKbs.indexOf(idx) !== -1 ? '' : 'none';
        } else {
          card.style.display = '';
        }
      });
    }

    function toggleKb(idx) {
      if (!isMobile()) return;
      if (activeKbs.indexOf(idx) !== -1) return;
      activeKbs.shift();
      activeKbs.push(idx);
      renderKbSelection();
      scheduleSyncSpecRowHeights();
      applyHighlight();
      notifyLayoutChange();
    }

    function applyLayout() {
      if (mobileTabBar) {
        mobileTabBar.setAttribute('aria-hidden', isMobile() ? 'false' : 'true');
      }
      if (isMobile()) {
        renderKbSelection();
      } else {
        getCards().forEach(function (card) {
          card.style.display = '';
        });
      }
      updateMobileTabLabels();
      scheduleSyncSpecRowHeights();
      applyHighlight();
      notifyLayoutChange();
    }

    function bindMobileTabs() {
      root.querySelectorAll('.kbc-kb-tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          toggleKb(parseInt(tab.dataset.kbIdx, 10));
        });
      });

      if (typeof mobileMq.addEventListener === 'function') {
        mobileMq.addEventListener('change', applyLayout);
      } else if (typeof mobileMq.addListener === 'function') {
        mobileMq.addListener(applyLayout);
      }
    }

    function syncSpecRowHeights() {
      var cards = getComparisonCards();
      if (!cards.length) return;

      // 1) Equalize dropdown header height across columns
      var dropdownWraps = [];
      cards.forEach(function (card) {
        var wrap = card.querySelector('.kb-card-dropdown-wrap');
        if (wrap) dropdownWraps.push(wrap);
      });
      equalizeElements(dropdownWraps);

      // 2) Equalize each direct child <div> inside the active panel across columns
      var panels = [];
      cards.forEach(function (card) {
        var panel = getVisiblePanel(card);
        if (panel) panels.push(panel);
      });

      if (panels.length) {
        var maxChildDivs = 0;
        var panelDivChildren = panels.map(function (panel) {
          var divs = Array.from(panel.children).filter(function (el) {
            return el && el.tagName === 'DIV';
          });
          maxChildDivs = Math.max(maxChildDivs, divs.length);
          return divs;
        });

        for (var childIdx = 0; childIdx < maxChildDivs; childIdx++) {
          var group = [];
          panelDivChildren.forEach(function (divs) {
            var el = divs[childIdx];
            if (el) group.push(el);
          });
          equalizeElements(group);
        }
      }

      for (var specIndex = 1; specIndex <= 12; specIndex++) {
        var rows = [];
        cards.forEach(function (card) {
          var panel = getVisiblePanel(card);
          if (!panel) return;
          var row = panel.querySelector('.spec-row[data-spec-index="' + specIndex + '"]');
          if (row) rows.push(row);
        });
        equalizeElements(rows);
      }

      cards.forEach(function (card) {
        var panel = getVisiblePanel(card);
        if (!panel) return;
        panel.querySelectorAll('.spec-group-title').forEach(function (title) {
          title.style.minHeight = '';
          title.style.height = '';
        });
      });
    }

    function scheduleSyncSpecRowHeights() {
      requestAnimationFrame(function () {
        syncSpecRowHeights();
        requestAnimationFrame(syncSpecRowHeights);
      });
    }

    function closeAllDropdowns() {
      root.querySelectorAll('.rk-dropdown-menu.open').forEach(function (menu) {
        menu.classList.remove('open');
        var trigger = menu.previousElementSibling;
        if (trigger && trigger.classList.contains('rk-dropdown-trigger')) {
          trigger.classList.remove('open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function bindDropdowns() {
      root.querySelectorAll('.rk-dropdown').forEach(function (dropdown) {
        var column = dropdown.dataset.column;
        var trigger = dropdown.querySelector('.rk-dropdown-trigger');
        var menu = dropdown.querySelector('.rk-dropdown-menu');
        var label = dropdown.querySelector('.rk-dropdown-label');

        if (!trigger || !menu) return;

        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          var isOpen = menu.classList.contains('open');
          closeAllDropdowns();
          if (!isOpen) {
            menu.classList.add('open');
            trigger.classList.add('open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });

        menu.querySelectorAll('.rk-dropdown-item').forEach(function (item) {
          item.addEventListener('click', function (e) {
            e.stopPropagation();
            var blockIndex = item.dataset.blockIndex;
            var title = item.dataset.title;
            var card = root.querySelector('.kb-card[data-column="' + column + '"]');

            menu.querySelectorAll('.rk-dropdown-item').forEach(function (i) {
              i.classList.remove('selected');
              i.setAttribute('aria-selected', 'false');
            });
            item.classList.add('selected');
            item.setAttribute('aria-selected', 'true');

            if (label) label.textContent = title;

            if (card) showPanel(card, blockIndex);

            closeAllDropdowns();
            updateMobileTabLabels();
            scheduleSyncSpecRowHeights();
            applyHighlight();

            root.dispatchEvent(
              new CustomEvent('kbc:product-change', {
                bubbles: true,
                detail: { column: column, blockIndex: blockIndex }
              })
            );
          });
        });
      });

      root.addEventListener('click', function (e) {
        if (!e.target.closest('.rk-dropdown')) closeAllDropdowns();
      });
    }

    function applyHighlight() {
      var cards = getComparisonCards();

      for (var specIndex = 1; specIndex <= 12; specIndex++) {
        var vals = [];
        cards.forEach(function (card) {
          var panel = getVisiblePanel(card);
          if (!panel) return;
          var row = panel.querySelector('.spec-row[data-spec-index="' + specIndex + '"]');
          if (row) {
            var val = row.querySelector('.spec-val');
            vals.push(val ? val.textContent.trim() : '');
          }
        });
        var unique = vals.filter(function (v, idx, arr) {
          return arr.indexOf(v) === idx;
        });
        var isDiff = unique.length > 1;

        cards.forEach(function (card) {
          var panel = getVisiblePanel(card);
          if (!panel) return;
          var row = panel.querySelector('.spec-row[data-spec-index="' + specIndex + '"]');
          if (row) row.classList.toggle('spec-diff', highlightOn && isDiff);
        });
      }
    }

    function toggleHighlight() {
      highlightOn = !highlightOn;
      root.classList.toggle('highlight-on', highlightOn);
      if (highlightBtn) highlightBtn.setAttribute('aria-pressed', highlightOn ? 'true' : 'false');
      applyHighlight();
    }

    function bindViewMore() {
      if (!viewMoreBtn) return;
      var viewMoreLabel = viewMoreBtn.dataset.viewMore || 'View More';
      var hideMoreLabel = viewMoreBtn.dataset.hideMore || 'Hide More';

      viewMoreBtn.addEventListener('click', function () {
        var collapsed = root.classList.toggle('hide-more');
        var arrow = viewMoreBtn.querySelector('.arrow-icon');
        var text = viewMoreBtn.querySelector('span');
        if (arrow) arrow.classList.toggle('arrow-rotate', !collapsed);
        if (text) text.textContent = collapsed ? viewMoreLabel : hideMoreLabel;
        viewMoreBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        scheduleSyncSpecRowHeights();
      });
    }

    function bindSwatches() {
      root.querySelectorAll('.kb-card-swatches .item-swatch li').forEach(function (li) {
        li.addEventListener('mouseenter', function () {
          var swatch = li.querySelector('.nochange');
          var imgUrl = swatch && swatch.dataset.imgurl;
          if (!imgUrl) return;
          var panel = li.closest('.kb-product-panel');
          var proImg = panel && panel.querySelector('.pro_img img');
          if (!proImg) return;
          proImg.src = imgUrl;
          if (proImg.dataset.src) proImg.dataset.src = imgUrl;
        });
        li.addEventListener('mouseleave', function () {
          var panel = li.closest('.kb-product-panel');
          var proImgWrap = panel && panel.querySelector('.pro_img');
          var proImg = proImgWrap && proImgWrap.querySelector('img');
          var defaultUrl = proImgWrap && proImgWrap.dataset.url;
          if (!proImg || !defaultUrl) return;
          proImg.src = defaultUrl;
          if (proImg.dataset.src) proImg.dataset.src = defaultUrl;
        });
      });
    }

    if (highlightBtn) highlightBtn.addEventListener('click', toggleHighlight);

    bindDropdowns();
    bindViewMore();
    bindSwatches();
    bindMobileTabs();
    initPanelVisibility();
    applyLayout();

    if (!root.dataset.kbcResizeBound) {
      root.dataset.kbcResizeBound = 'true';
      var resizeTimer;
      window.addEventListener('resize', function () {
        if (!root.isConnected) return;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(applyLayout, 150);
      });
    }

    var specGrid = root.querySelector('.spec-grid');
    if (specGrid && typeof ResizeObserver !== 'undefined') {
      var gridWidth = specGrid.offsetWidth;
      var roTimer;
      var gridObserver = new ResizeObserver(function () {
        if (specGrid.offsetWidth === gridWidth) return;
        gridWidth = specGrid.offsetWidth;
        clearTimeout(roTimer);
        roTimer = setTimeout(scheduleSyncSpecRowHeights, 100);
      });
      gridObserver.observe(specGrid);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleSyncSpecRowHeights);
    }
  }

  function boot() {
    document.querySelectorAll('.keyboard-comparison').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target && event.target.querySelector('.keyboard-comparison');
    if (el) initSection(el);
  });
})();
